import { toast } from "sonner";

function useToast() {
  return { toast };
}

export { useToast, toast };
